// extracted by mini-css-extract-plugin
export default {"search-button":"style_search-button__gobzZ"};